import {PhotoTagType} from './phototool-tags';

export function getLocalizedTagName(shortLocaleName: string, tag: PhotoTagType): string {
    const translationItem = tag.translations.find(({languageCode}) => shortLocaleName === languageCode);

    return translationItem?.translation || tag.name;
}
